// extracted by mini-css-extract-plugin
export default {"success":"StatusIcon_success__7gEjQ","error":"StatusIcon_error__doHfs","warning":"StatusIcon_warning__18Lmw","info":"StatusIcon_info__z+w0M"};